<template>
  <button class="rating" aria-label="Show rate conversation buttons">
    {{ rating }}
    <IconRatingStar width="12px" height="12px" fill="#222C50" aria-hidden="true" />
  </button>
</template>

<script setup lang="ts">
import IconRatingStar from '@/svg/IconRatingStar.vue';

defineProps<{
  rating: number
}>()
</script>

<style scoped lang="scss">
.rating {
  border: none;
  margin: 0;
  font-size: 1.3rem;
  padding: .25rem .75rem;
  border-radius: 1rem;
  background: #E0E0E0;
  color: #222C50;
  display: flex;
  align-items: center;
  width: fit-content;
  line-height: 100%;
  gap: .25rem;
  cursor: pointer;

  @include default-focus;
  &:focus-visible {
    outline-color: var(--moin-widget-header-textcolor);
  }
}

.rating:hover {
  background: #cccccc;
}
</style>
